import Badge from '@scuf/common/dist/components/Badge/Badge';
import { statusOptions, typeOptions } from 'models';
import { useRecoilValue } from 'recoil';
import { rmaDetailState } from 'resources';
import 'styles/main.scss';

function BadgeStatusType() {
    const rmaList = useRecoilValue(rmaDetailState);

    return (
        <>
            <Badge color={statusOptions.find(e => e.value === rmaList?.StatusId)?.color}>
                {statusOptions.find(e => e.value === rmaList?.StatusId)?.text}
            </Badge>
            <Badge color={typeOptions.find(e => e.value === rmaList?.TypeId)?.color}>
                {typeOptions.find(e => e.value === rmaList?.TypeId)?.text}
            </Badge>
        </>
    );
}

export default BadgeStatusType;
